import EditableTitle from './container';

export default EditableTitle;



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/EditableTitle/index.js